import ServiceMan from "./ServiceMan";

export default ServiceMan;